import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Nav = styled.nav`
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Float links to the left */
  background-color: #000; /* Dark background for navigation */
  padding: 0 20px; /* Add horizontal padding */
  box-sizing: border-box;
`;

const NavLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  margin-right: 15px; /* Space between links */

  &:hover {
    text-decoration: underline; /* Add underline on hover */
  }
`;

const Navigation = () => {
  return (
    <Nav>
      <NavLink to="/">Projects</NavLink>
      <NavLink to="/about">About</NavLink>
      <NavLink to="/contact">Contact</NavLink>
    </Nav>
  );
};

export default Navigation;
